import MojitoCore from 'mojito/core';

import {mergeTo} from '#core/utils/config-utils.js';

import {BasePalette} from '#core/application/modules/base-palette.js';
import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

// import {actions as visualConfigActions} from '#core/application/modules/visual-config-actions.js';

import {ApplicationHeader} from '../../application-header.js';

import {mainNavigationBarAvantgardeFactory} from './main-navigation-bar-avantgarde.factory.js';

import SCHEMA from './main-navigation-bar-avantgarde.schema.yaml';
import PALETTE_SCHEMA from './main-navigation-bar-avantgarde.palette-schema.yaml';

const reduxInstance = MojitoCore.Services.redux;
// const {dispatch} = reduxInstance.store;
const {actions: SystemSettingsActions} = MojitoCore.Services.SystemSettings;

class MainNavigationBarAvantgardeFeature extends AbstractVisualFeature {
    constructor(parent) {
        super(parent);

        reduxInstance.actionListener.startListening({
            actionCreator: SystemSettingsActions.updateColorTheme,
            effect: action => {
                document.documentElement.setAttribute('data-theme', action.payload.colorTheme);
                // dispatch(visualConfigActions.rebuildAndApplyVisualFromConfig());
            },
        });
    }

    get enabled() {
        return BasePalette.isAvantgarde();
    }

    get name() {
        return 'Main Navigation Bar Avantgarde';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {settingsMenu} = this.config;

        return mergeTo(mainNavigationBarAvantgardeFactory(PALETTE), {
            SettingsMenuAvantgarde: {
                showLanguage: settingsMenu.showLanguage,
                showOddsFormat: settingsMenu.showOddsFormat,
                showTimeOffset: settingsMenu.showTimeOffset,
            },
        });
    }
}

new MainNavigationBarAvantgardeFeature(ApplicationHeader);
